module.exports = __webpack_public_path__ + "img/zotapay.73a662ec.svg";